import { useEffect } from 'react';
import { useLocalObservable, observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { PageContent } from 'components/Page';
import { useStore } from 'models/Provider';
import { PromotePost } from './PromotePost';
import { PromoteSelectBoard } from './PromoteSelectBoard';

export const PromoteCreate = observer(({ boards, selected = null }) => {
  const { api } = useStore();
  const params = useParams();

  const state = useLocalObservable(() => ({
    job: null,
    selectedBoard: selected,
    setJob(job) {
      state.job = job;
    },
    resetBoard() {
      state.selectedBoard = null;
    },
    selectBoard(board) {
      state.selectedBoard = board;
    },
  }));

  useEffect(() => {
    api.jobs.loadFromDb(params.jobID).then((res) => {
      !res.error && state.setJob(res.data);
    });
  }, [params.jobID, api.jobs, state]);

  if (!state.job) return null;

  if (!state.selectedBoard) {
    return (
      <PageContent alwaysScroll={false}>
        <PromoteSelectBoard selectBoard={state.selectBoard} boards={boards} />
      </PageContent>
    );
  }

  return (
    <PageContent alwaysScroll={false}>
      <div style={{ maxWidth: 1440 }}>
        <PromotePost
          job={state.job}
          selectedBoard={state.selectedBoard}
          resetSelectedBoard={state.resetBoard}
        />
      </div>
    </PageContent>
  );
});
